import gql from 'graphql-tag';

export default gql`
  query GetAllShops($statusFilter: ShopStatus, $searchTerm: String) {
    shops(
      orderBy: name_ASC,
      where: { status: $statusFilter, OR: [{ name_contains: $searchTerm }, { description_contains: $searchTerm }] }
    ) {
      id
      name
      description
      status
      logo
      email
      telephoneNumber
      whatsappNumber
      menus
      pdfs
      tradingHours
      mondayHours
      tuesdayHours
      wednesdayHours
      thursdayHours
      fridayHours
      saturdayHours
      sundayHours
      isService
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetAllShops.ts